import req from '../../api/request'
import type { TimeoutRow } from '../../features/game/scoring/types/timeout'

export interface TimeoutCountInput {
  gameId: string
  periodId: string
  /** The team's id, as the API knows it (its uid). */
  teamId: string
  count: number
}

/**
 * PUT /games/:gameId/periods/:periodId/timeouts/bulk
 *
 * Sets how many timeouts a team called in a period. A basic-stats game's
 * timeline shows its timeouts as a count, as it shows its points and shots.
 * The API records the missing ones at the period's own clock and removes the
 * extra ones, the last recorded first. Sending the same count again changes
 * nothing, so the request wrapper's own retries are safe.
 *
 * Returns the team's timeouts in the period afterwards.
 */
export const setTimeoutCount = async ({
  gameId,
  periodId,
  teamId,
  count,
}: TimeoutCountInput): Promise<TimeoutRow[]> => {
  const { data } = await req(
    `/games/${gameId}/periods/${periodId}/timeouts/bulk`,
    {
      method: 'PUT',
      body: JSON.stringify({ team_id: teamId, timeouts: count }),
    }
  )
  return data
}
